var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDmmIcon01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 81.303,
    height: 101.668,
    viewBox: "0 0 81.303 101.668",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21",
    "data-name": "Rectangle 21",
    width: 81.303,
    height: 101.668,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M482.576,52.9l0,.869a5.261,5.261,0,0,0,5.261,5.242h0c7.885,0,11.347,1.189,13.464,3.307L479.269,40.285c2.112,2.112,3.307,4.731,3.307,12.617",
    transform: "translate(-479.269 -40.285)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -1.608,
    y1: 3.262,
    x2: -1.604,
    y2: 3.262,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6b7dce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.212,
    stopColor: "#6881ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463,
    stopColor: "#6290bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733,
    stopColor: "#58a8ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4cc795"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_139",
    "data-name": "Group 139",
    transform: "translate(-235.043 -879.295)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67",
    "data-name": "Group 67",
    transform: "translate(235.043 879.295)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M35.094,0H4.71A4.71,4.71,0,0,0,0,4.71V96.958a4.71,4.71,0,0,0,4.71,4.71H74.05a4.71,4.71,0,0,0,4.71-4.71v-51.6c0-12.549-1.653-15.788-4.6-18.731L52.129,4.6C49.187,1.653,44.675,0,35.094,0",
    transform: "translate(0 0)",
    fill: "#e1e1e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M57.391,0H27.007A4.71,4.71,0,0,0,22.3,4.71V96.958a4.71,4.71,0,0,0,4.71,4.71h69.34a4.71,4.71,0,0,0,4.71-4.71v-51.6c0-12.549-1.653-15.788-4.6-18.731L74.426,4.6C71.484,1.653,66.972,0,57.391,0",
    transform: "translate(-19.753 0)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(54.673 4.596)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22",
    "data-name": "Rectangle 22",
    width: 31.162,
    height: 31.162,
    transform: "translate(-11.017 11.017) rotate(-45)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M232.4,422.23H193.85a.6.6,0,0,1-.6-.6v-5.315a.6.6,0,0,1,.6-.6H232.4a.6.6,0,0,1,.6.6v5.315a.6.6,0,0,1-.6.6",
    transform: "translate(-171.202 -368.287)",
    fill: "#3b51eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M232.4,527.773H193.85a.6.6,0,0,1-.6-.6v-5.315a.6.6,0,0,1,.6-.6H232.4a.6.6,0,0,1,.6.6v5.315a.6.6,0,0,1-.6.6",
    transform: "translate(-171.202 -461.79)",
    fill: "#3b51eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M221.043,633.315H193.85a.6.6,0,0,1-.6-.6V627.4a.6.6,0,0,1,.6-.6h27.194a.6.6,0,0,1,.6.6v5.315a.6.6,0,0,1-.6.6",
    transform: "translate(-171.202 -555.292)",
    fill: "#3b51eb"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDmmIcon01);
export default __webpack_public_path__ + "static/media/DMM_icon01.2539c306e673e9cd50fc85c38ea9b9c3.svg";
export { ForwardRef as ReactComponent };